
import React, {
  Suspense
} from 'react';
// React dom added to render the components.
import ReactDOM from 'react-dom';
// Context provider.
import { GameStateProvider } from './context/provider';
// Login Component.
import Login from './components/login/Login';
// Bootstrap style added.
import 'bootstrap/dist/css/bootstrap.min.css';
//import styles
import './index.css';

// Application starts here.
ReactDOM.render(
  // Strict mode added.
  <React.StrictMode>
    <GameStateProvider>
      {/* Suspense added */}
      <Suspense
        fallback={
          <div>Loading...</div>
        }
      >
        {/* Login */}
        <Login />
      </Suspense>
    </GameStateProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
